export default __webpack_public_path__ + "static/media/crew-04-bit.f995f9f2.svg";